import { render, staticRenderFns } from "./TransferSchedulesTable.vue?vue&type=template&id=5470bb7b&scoped=true"
import script from "./TransferSchedulesTable.vue?vue&type=script&lang=ts"
export * from "./TransferSchedulesTable.vue?vue&type=script&lang=ts"
import style0 from "./TransferSchedulesTable.vue?vue&type=style&index=0&id=5470bb7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5470bb7b",
  null
  
)

export default component.exports